import { toBuilderError } from "../api/errors";

/** Server limit for a trimmed message. */
export const MESSAGE_LIMIT = 4000;
/** What a message says when the owner sends inspiration images without writing anything (the server says the same). */
export const DEFAULT_REFERENCE_TEXT = "Here’s some inspiration.";

/** Stable client ID for one message, reused for every resend. Matches `[A-Za-z][A-Za-z0-9_-]{0,63}`. */
export function newMessageId(): string {
  return `msg-${crypto.randomUUID()}`;
}

export function messageProblem(text: string): "empty" | "too-long" | null {
  const trimmed = text.trim();
  if (!trimmed) return "empty";
  return trimmed.length > MESSAGE_LIMIT ? "too-long" : null;
}

/**
 * What a failed send means.
 * - `busy`: another request is still being worked on (409). Not accepted.
 * - `limited`: the hourly limit was reached (429). Not accepted.
 * - `refused`: the server rejected the message as sent (other 4xx). Not accepted.
 * - `unknown`: it may or may not have been accepted; resend the same ID and text.
 */
export type SendOutcome = "busy" | "limited" | "refused" | "signed-out" | "not-found" | "unknown";

export function sendOutcome(caught: unknown): SendOutcome {
  const error = toBuilderError(caught);
  if (error.failure === "signed-out" || error.failure === "not-found") return error.failure;
  if (error.outcomeUnknown) return "unknown";
  if (error.status === 409) return "busy";
  if (error.status === 429) return "limited";
  return "refused";
}
